import { render, staticRenderFns } from "./TicketScroll.vue?vue&type=template&id=c160c85a&scoped=true&"
import script from "./TicketScroll.vue?vue&type=script&lang=js&"
export * from "./TicketScroll.vue?vue&type=script&lang=js&"
import style0 from "./TicketScroll.vue?vue&type=style&index=0&id=c160c85a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c160c85a",
  null
  
)

export default component.exports